import { render } from "./PostCategory.vue?vue&type=template&id=4c393d3f&scoped=true"
import script from "./PostCategory.vue?vue&type=script&lang=js"
export * from "./PostCategory.vue?vue&type=script&lang=js"

import "./PostCategory.vue?vue&type=style&index=0&id=4c393d3f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c393d3f"]])

export default __exports__